export type WrapupUser = {
    id: number;
    name: string;
    avatar: string;
    favoriteColor?: number;
}

export type WrapupMap = {
    id: number;
    name: string;
    asset: string;
}

export type GetWrapupType = null | {
    data: any;
    users: WrapupUser[];
    maps: WrapupMap[];
    user: WrapupUser;
}

export type WrapupModulePlayedData = {
    numPlayed: number;
    numWon: number;
    rank: number;
    totalUsers: number;
    gameModes: [number, number][];
};

export type WrapupModuleMapData = {
    mapPlays: [number, number][];
    topMap: {
        mapId: number;
        totalPlays: number;
        rank: number;
        totalUsers: number;
    }
}

export type WrapupModuleCombatData = {
    countriesCaptured: number;
    totalUsers: number;
    turns: number;
    unitsKilled: number;
    unitsKilledRank: number;
    unitsLost: number;
    unitsLostRank: number;
}

export type WrapupModuleKillsData = {
    botDeaths: number;
    botKills: number;
    deathCount: number;
    killCount: number;
    killedByUserIds: [number, number][];
    killedUserIds: [number, number][];
    sprees: [number, number][];
}

export type WrapupModuleTeamsData = {
    teamGames: number;
    teammates: [number, number, number][];
}

export enum WrapupGameMode {
    Standard = 0,
    Teams,
    Percent,
    Catan,
    Capitals,
    Assassin,
}
